import { useReveal } from "../../lib/useReveal";

const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_57d85e2a-e3d9-489b-aea5-c3202d03fe13/artifacts/xzltz4c8_ChatGPT%20Image%208%20de%20mai.%20de%202026%2C%2018_11_09.png";

export default function Hero() {
    const ref = useReveal();
    const scroll = (id) =>
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

    return (
        <section
            data-testid="hero-section"
            className="relative min-h-screen flex items-center pt-32 pb-20 overflow-hidden hero-bg-noise"
        >
            <div className="grain-overlay" />
            <div className="absolute inset-0 hero-vignette pointer-events-none" />

            {/* Vertical accent line */}
            <div className="absolute left-6 lg:left-10 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#d4af37]/30 to-transparent" />
            <div className="absolute right-6 lg:right-10 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-white/5 to-transparent" />

            <div ref={ref} className="reveal max-w-7xl mx-auto px-6 lg:px-10 w-full relative z-10">
                <div className="flex items-center gap-4 mb-10">
                    <span className="h-px w-12 bg-[#d4af37]" />
                    <span className="tag-fluxo" data-testid="hero-tag">
                        Estrutura Privada de Aquisição Comercial
                    </span>
                </div>

                <h1
                    data-testid="hero-headline"
                    className="font-['Outfit'] font-black uppercase tracking-[-0.03em] leading-[0.92] text-[40px] sm:text-[58px] md:text-[78px] lg:text-[96px] xl:text-[110px] max-w-[1200px]"
                >
                    <span className="block text-white">Investimos em demanda.</span>
                    <span className="block text-white/80">Assumimos a venda.</span>
                    <span className="block text-gold-gradient">
                        Participamos do resultado.
                    </span>
                </h1>

                <div className="mt-12 max-w-2xl">
                    <p
                        data-testid="hero-sub"
                        className="text-white/60 text-base md:text-lg leading-relaxed font-['Manrope']"
                    >
                        A FLUXO NAS VENDAS opera como parceiro comercial de crescimento.
                        Investimos na aquisição, assumimos a conversão e participamos{" "}
                        <span className="text-white">apenas da receita</span> que ajudamos
                        a criar.
                    </p>
                </div>

                <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-5">
                    <button
                        data-testid="hero-cta-primary"
                        onClick={() => scroll("cta-final")}
                        className="btn-gold px-8 py-4 text-[12px] uppercase tracking-[0.28em] font-bold font-['Outfit']"
                    >
                        <span>Verificar Elegibilidade →</span>
                    </button>
                    <button
                        data-testid="hero-cta-secondary"
                        onClick={() => scroll("como-operamos")}
                        className="text-[12px] uppercase tracking-[0.28em] text-white/60 hover:text-[#d4af37] transition-colors font-['Outfit'] py-4 flex items-center gap-3"
                    >
                        Como Operamos
                        <span className="h-px w-10 bg-white/20" />
                    </button>
                </div>

                {/* Bottom strip */}
                <div className="mt-24 lg:mt-32 grid grid-cols-1 sm:grid-cols-3 gap-8 border-t border-white/5 pt-10 max-w-4xl">
                    {[
                        ["01", "Aquisição", "Capital próprio investido"],
                        ["02", "Conversão", "Operação comercial assumida"],
                        ["03", "Participação", "Apenas sobre receita gerada"],
                    ].map(([n, t, d]) => (
                        <div key={n} data-testid={`hero-pillar-${n}`}>
                            <div className="text-[#d4af37] text-[11px] tracking-[0.32em] mb-2 font-['Outfit']">
                                {n}
                            </div>
                            <div className="text-white font-['Outfit'] font-semibold text-lg mb-1">
                                {t}
                            </div>
                            <div className="text-white/40 text-sm">{d}</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Bottom logo watermark */}
            <img
                src={LOGO_URL}
                alt=""
                aria-hidden="true"
                className="absolute -right-32 -bottom-32 w-[520px] opacity-[0.04] pointer-events-none select-none"
            />
        </section>
    );
}
